<template lang="pug">
  v-dialog(v-model='dialog' persistent='' max-width='60%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='8')
                    v-text-field(dense outlined :readonly='read' v-model='form.nombreEmpresa' label='Empresa')
                  v-col(cols='12' xs='12' sm='6' md='4' class='d-flex justify-center')
                    div(class="d-flex justify-space-around")
                      div(class="pa-0 mr-2" style="width:70px")
                        v-select(dense outlined v-model='rifLetra' :items='items' :readonly='read')
                      div(class="pa-0")#rifC
                        v-text-field(dense outlined v-model='rifNumerico' hint="Requerido" persistent-hint :readonly='read' label='RIF' v-mask="'#########'")
                v-row(dense)
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined :readonly='read' v-model='form.tlf' label='Teléfono' v-mask="'(####)###-##-##'")
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined :readonly='read' v-model='form.correo' label='Correo')
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined type='number' min="0" :readonly='read' v-model='form.zonaPostal' label='Zona Postal')
                v-row(dense)
                  v-col(cols='12' sm='12' md='12')
                    v-textarea(dense outlined :readonly='read' v-model='form.direccion' label='Dirección')
          p
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle.title(style='color: black') Información del Encargado
              v-card-text
                v-row(dense class='d-flex justify-center')
                  v-col(cols='12' sm='12' md='4')
                    v-text-field(dense outlined :readonly='read' v-model='form.nombreEncargado' label='Encargado')
                v-row(dense)
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense outlined :readonly='read' v-model='form.correo1' label='Correo 1')
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense outlined :readonly='read' v-model='form.tlf1' label='Teléfono 1' v-mask="'(####)###-##-##'")
                v-row(dense)
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense outlined :readonly='read' v-model='form.correo2' label='Correo 2')
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense outlined :readonly='read' v-model='form.tlf2' label='Teléfono 2' v-mask="'(####)###-##-##'")
                v-row(dense)
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense outlined :readonly='read' v-model='form.correo3' label='Correo 3')
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense outlined :readonly='read' v-model='form.tlf3' label='Teléfono 3' v-mask="'(####)###-##-##'")
      v-card-actions
        v-spacer
        v-btn(color='error' small='' dark='' @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(v-if='!read' color='success' small='' dark='' @click='save')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    search: '',
    rifNumerico: '',
    rifLetra: 'J',
    items: ['V', 'E', 'J', 'P', 'G', 'C'],
    form: {
      nombreEmpresa: '',
      rif: '',
      direccion: '',
      zonaPostal: 0,
      tlf: '',
      correo: '',
      nombreEncargado: '',
      tlf1: '',
      correo1: '',
      tlf2: '',
      correo2: '',
      tlf3: '',
      correo3: ''
    },
    defaultItem: {
      nombreEmpresa: '',
      rif: '',
      direccion: '',
      zonaPostal: 0,
      tlf: '',
      correo: '',
      nombreEncargado: '',
      tlf1: '',
      correo1: '',
      tlf2: '',
      correo2: '',
      tlf3: '',
      correo3: ''
    }
  }),
  
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nuevo Consignado'
        : this.read
          ? 'Informacion del Consignado'
          : 'Modificar Consignado'
    }
  },

  watch: {
    FormPadre (val) {
      if (Object.keys(val).length !== 0) {
        this.form = val
        this.desconcatenarRif(val.rif)
      }
    }
  },

  created () {},

  methods: {
    concatenarRif () {
      this.form.rif = this.rifLetra + '-' + this.rifNumerico
    },
    desconcatenarRif (rif) {
      this.rifLetra = rif.charAt(0)
      this.rifNumerico = rif.substr(2)
    },

    close () {
      this.rifNumerico = ''
      this.rifLetra = 'J'
      this.form.rif = ''
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultForm)
      }, 300)
      this.$emit('close')
    },

    save () {
      this.concatenarRif()
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      if (this.editedIndex > -1) {
        Api.put('consignado', this.form)
          .then(res => {
            if (res.data.status === 'denied') {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: res.data.message
              })
            } else {
              this.$emit('edited', this.form)
              this.$swal({
                icon: 'success',
                title: 'Modificación exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            }
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor, verique su conexión de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      } else {
        Api.post('consignado', this.form)
          .then(res => {
            if (res.data.status === 'denied') {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: res.data.message
              })
            } else {
              this.$emit('save', this.form)
              this.$swal({
                icon: 'success',
                title: 'Inclusión exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            }
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor, verique su conexión de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }
  }
}
</script>
